import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ModalWindow, Text, useDateTimeFormat, useLocalizeMessage } from 'libs.nucleus';
import { ListInformation } from 'libs.react';
import { getResponseValueForTLFBStep } from '../../helpers/step_response.helpers';
var SCREEN_TYPES;
(function (SCREEN_TYPES) {
    SCREEN_TYPES["TLFB"] = "tlfb";
})(SCREEN_TYPES || (SCREEN_TYPES = {}));
export const DetailedResponseValueModal = ({ isOpen, onClose, stepResponse, title, }) => {
    const translate = useLocalizeMessage();
    const { formatPlainDate } = useDateTimeFormat();
    const screenType = stepResponse.c_step?.c_screen_details?.c_screen_type;
    const body = useMemo(() => {
        switch (screenType) {
            case SCREEN_TYPES.TLFB: {
                const parsed = getResponseValueForTLFBStep(stepResponse);
                const rows = Object.entries(parsed).map(([dateKey, val]) => ({
                    title: formatPlainDate(dateKey),
                    description: _jsx("div", { className: 'w-full flex justify-end', children: String(val) }),
                }));
                return _jsx(ListInformation, { items: rows });
            }
            default:
                return (_jsx(Text, { className: 'whitespace-pre-wrap break-words', "data-testid": 'step-response-detail-default', children: stepResponse.c_value }));
        }
    }, [screenType, stepResponse.c_value, formatPlainDate, translate]);
    return (_jsx(ModalWindow, { title: title || translate('generic.response_details'), isOpen: isOpen, closeWindow: onClose, width: 'lg', footerSecondaryActionButtons: [{ label: translate('generic.done'), onClick: onClose }], dataTestId: 'step-response-detail-modal', children: body }));
};
